import { Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";

@Component({
    selector: "datepicker-storybook",
    templateUrl: "./datepicker-storybook.component.html",
})
export class DatePickerStorybookComponent {
    form = new FormGroup({
        date: new FormControl(null),
        range: new FormControl(null),
    });
}
